// Main entry — the production View. (No Container: FieldRow is a pure
// View.) Sim wrappers live under ./sim and are never imported here, so a
// production import of FieldRow can't pull in fixtures.
export { FieldRow } from "./FieldRow";
export type { FieldRowProps } from "./FieldRow";
